<template lang="pug">
  .box-header-group.box-row-pc(:class="[isOpen ? 'open-expand' : '']")
    .item-header
      .item-content
        .item-title(@click="openRowPC")
          i.fa(:class="[isOpen ? 'fa-chevron-down' : 'fa-chevron-right']")
          span {{ item.name }}
      .item-number-count
        .item-group(@click="gotoListLesson(item)")
          span {{$mycontroller.numberWithCommas(countLesson)}}
          img(src="../../assets/images/faces/ic_lythuyet@2x.png")
        .item-group(@click="gotoListVideo(item)")
          span {{$mycontroller.numberWithCommas(countVideo)}}
          img(src="../../assets/images/faces/ic_video@2x.png")
        .item-group(@click="gotoListExercise(item)")
          span {{$mycontroller.numberWithCommas(countExercise)}}
          img(src="../../assets/images/faces/ic_baitap@2x.png")
      .clearfix
    .item-body(v-if="lstClasses && lstClasses.length > 0")
      .item-classes-planing-pc(v-for="(classes, index) in lstClasses")
        ItemClasses(:item="classes" :key="increment" :pcID="item.id")
    .clearfix
</template>
<script>
import gql from 'graphql-tag'
import graphql from '../Model/graphql'
import MdNotification from '@/core/components/mdNotification'
import moment from 'moment'
import ItemClasses from '../Lesson_Planning/itemClasses'
export default {
  components: {
    MdNotification,
    ItemClasses
  },
  props: {
    item: Object
  },
  data() {
    return {
      lstClasses: (this.item.classes !== undefined && this.item.classes !== null) ? this.item.classes : null,
      message: this.$t('home.comming_soon'),
      increment: 0,
      loader: null,
      isOpen: false,
      countLesson: 0,
      countVideo: 0,
      countExercise: 0
    }
  },
  methods: {
    showNotification(message, color, from, align, timeout) {
      this.$notifications.notify({
        type: color,
        icon: 'notifications',
        message: message,
        placement: {
          from,
          align
        },
        timeout: timeout
      })
    },
    show() {
      this.loader = this.$loading.show({
        color: '#ffffff',
        loader: 'spinner',
        width: 60,
        height: 60,
        backgroundColor: '#000000',
        opacity: 0.5,
        zIndex: 9999,
        container: null,
        canCancel: true,
        onCancel: this.onCancel
      })
    },
    openRowPC() {
      this.isOpen = !this.isOpen
    },
    autoIncrement() {
      this.increment++
    },
    formatDate(value) {
      return moment(value).format('DD/MM/YYYY - HH:mm')
    },
    gotoListLesson(item) {
      this.$router.push({name: 'lesson_planning_lesson', query: {id: item.id}})
    },
    gotoListVideo(item) {
      this.$router.push({name: 'lesson_planning_video', query: {id: item.id}})
    },
    gotoListExercise(item) {
      this.$router.push({name: 'lesson_planning_exercise', query: {id: item.id}})
    },
    async getCountLesson() {
      var variables = {
        lesson: {type_lesson: {_eq: 1}},
        class: {pc_id: {_eq: this.item.id}}
      }
      const {data} = await this.$apollo.query({
        query: gql(graphql.GET_COUNT_LESSON_CLASS_DISTINCT_IN_PC),
        fetchPolicy: 'no-cache',
        variables: {
          where: variables
        }
      }).catch((error) => {
        if (error.graphQLErrors[0].extensions.code === 'invalid-jwt') {
          this.$router.go(0)
        }
        console.error(error.message)
      })
      if (data && data !== null) {
        this.countLesson = data.lesson_class_aggregate.aggregate.count
      }
    },
    async getCountVideo() {
      var variables = {
        lesson: {type_lesson: {_eq: 2}},
        class: {pc_id: {_eq: this.item.id}}
      }
      const {data} = await this.$apollo.query({
        query: gql(graphql.GET_COUNT_LESSON_CLASS_DISTINCT_IN_PC),
        fetchPolicy: 'no-cache',
        variables: {
          where: variables
        }
      }).catch((error) => {
        if (error.graphQLErrors[0].extensions.code === 'invalid-jwt') {
          this.$router.go(0)
        }
        console.error(error.message)
      })
      if (data && data !== null) {
        this.countVideo = data.lesson_class_aggregate.aggregate.count
      }
    },
    async getCountExercise() {
      var variables = {
        class: {pc_id: {_eq: this.item.id}}
      }
      const {data} = await this.$apollo.query({
        query: gql(graphql.GET_COUNT_EXERCISE_DISTINCT_IN_PC),
        fetchPolicy: 'no-cache',
        variables: {
          where: variables
        }
      }).catch((error) => {
        if (error.graphQLErrors[0].extensions.code === 'invalid-jwt') {
          this.$router.go(0)
        }
        console.error(error.message)
      })
      if (data && data !== null) {
        this.countExercise = data.exercise_class_aggregate.aggregate.count
      }
    }
  },
  async mounted () {
    if (this.$route.params.reload === 1) {
      console.log('reload')
    }
    await this.getCountLesson()
    await this.getCountVideo()
    await this.getCountExercise()
  },
  apollo: {
  }
}
</script>

<style lang="scss">
 
@media screen and (min-width: 768px){
  
}
@media screen and (max-width: 768px){
  
}
</style>



// WEBPACK FOOTER //
// item.vue?9e16025c